<template>
  <div
    v-if="prices && prices.length"
    class="fuel-planner__fuel-cards"
    :class="compact ? 'fuel-planner__fuel-cards--compact' : null"
  >
    <div
      v-for="(p, idx) in prices"
      :key="p.fuel_key || p.fuel_label || idx"
      class="fuel-planner__fuel-card"
    >
      <span
        class="fuel-planner__fuel-card-badge"
        :class="fuelBadgeClass(p.fuel_key || p.fuel_label || p.type)"
      >
        {{ p.fuel_label || p.type || p.fuel_key }}
      </span>
      <div class="fuel-planner__fuel-card-line1">
        <span class="fuel-planner__fuel-card-price">
          {{ p.is_estimated ? '~' : '' }}{{ formatFuelCardPrice(p.value ?? p.price) }}
        </span>
        <span
          v-if="formatPercentChange(p.changes)"
          class="fuel-planner__fuel-card-percent"
          :class="
            p.changes?.percent < 0
              ? 'fuel-planner__fuel-card-percent--down'
              : 'fuel-planner__fuel-card-percent--up'
          "
        >{{ formatPercentChange(p.changes) }}</span>
      </div>
      <div
        v-if="formatRubChange(p.changes)"
        class="fuel-planner__fuel-card-rub"
      >
        {{ formatRubChange(p.changes) }}
      </div>
      <div
        v-if="p.changes?.last_date"
        class="fuel-planner__fuel-card-updated"
      >
        Обновлено: {{ p.changes.last_date }}
      </div>
      <div
        v-for="line in restrictionDisplayLines(p.restrictions)"
        :key="line.key"
        class="fuel-planner__fuel-card-restriction"
      >
        {{ line.text }}
      </div>
    </div>
  </div>
</template>

<script>
  import {
    fuelBadgeClass,
    formatFuelCardPrice,
    formatPercentChange,
    formatRubChange,
    restrictionDisplayLines
  } from '@/utils/fuelPriceDisplay'

  export default {
    name: 'FuelPriceCards',
    props: {
      prices: {
        type: Array,
        default: () => []
      },
      compact: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      fuelBadgeClass,
      formatFuelCardPrice,
      formatPercentChange,
      formatRubChange,
      restrictionDisplayLines
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  .fuel-planner__fuel-cards {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
  }

  .fuel-planner__fuel-card {
    flex: 0 1 auto;
    min-width: 140px;
    max-width: 140px;
    padding: 8px 10px;
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #e6eaee;
    border-radius: 8px;
  }

  .fuel-planner__fuel-cards--compact .fuel-planner__fuel-card {
    min-width: 96px;
    max-width: 140px;
    padding: 6px 8px;
  }

  .fuel-planner__fuel-card-badge {
    display: inline-block;
    margin-bottom: 6px;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.35;
    color: #fff;
    white-space: nowrap;

    &--ai92 {
      background: $green;
    }

    &--ai95 {
      background: #d4a017;
    }

    &--dt {
      background: $black;
    }

    &--other {
      background: $grey_2;
    }
  }

  .fuel-planner__fuel-card-line1 {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4px 6px;
  }

  .fuel-planner__fuel-card-price {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
    color: $black;
  }

  .fuel-planner__fuel-card-percent {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;

    &--up {
      color: $red;
    }

    &--down {
      color: $green;
    }
  }

  .fuel-planner__fuel-card-rub {
    margin-top: 2px;
    font-size: 12px;
    line-height: 1.3;
    color: $grey_2;
  }

  .fuel-planner__fuel-card-updated,
  .fuel-planner__fuel-card-restriction {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    color: $grey_2;
  }

  .fuel-planner__fuel-cards--compact {
    .fuel-planner__fuel-card-price {
      font-size: 13px;
    }

    .fuel-planner__fuel-card-percent,
    .fuel-planner__fuel-card-rub {
      font-size: 11px;
    }

    .fuel-planner__fuel-card-updated,
    .fuel-planner__fuel-card-restriction {
      font-size: 10px;
    }
  }
</style>
